module.exports = __webpack_public_path__ + "static/img/ndvi_8.a9b6046c.jpg";